import React, { useEffect } from 'react';
import { Instagram, ExternalLink } from 'lucide-react';
import { BRAND } from '../mock';

// Custom TikTok icon
const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.45a8.16 8.16 0 0 0 4.77 1.52V6.55a4.85 4.85 0 0 1-1.84-.16z" />
  </svg>
);

const FacebookIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.08 5.66 21.25 10.44 22v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.24.19 2.24.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.77l-.44 2.91h-2.33V22C18.34 21.25 22 17.08 22 12.06z" />
  </svg>
);

const BEHOLD_ID = 'jCKaqDve9xjpWFJytorC';
const BEHOLD_SCRIPT_SRC = 'https://w.behold.so/widget.js';

const InstagramFeed = () => {
  useEffect(() => {
    // Inject the Behold widget script only once across the app
    if (document.querySelector(`script[src="${BEHOLD_SCRIPT_SRC}"]`)) return;
    const s = document.createElement('script');
    s.type = 'module';
    s.src = BEHOLD_SCRIPT_SRC;
    s.async = true;
    document.head.appendChild(s);
  }, []);

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-10 reveal">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[color:var(--brand-50)] text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3">
            <Instagram className="w-3.5 h-3.5" /> Media Sosial
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)]">
            Ikuti kami di <span className="text-[color:var(--brand)]">{BRAND.instagramHandle}</span>
          </h2>

          {/* Social buttons */}
          <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
            <a
              href={BRAND.instagram}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
              style={{ background: 'linear-gradient(45deg, #f09433, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888)' }}
            >
              <Instagram className="w-4 h-4" /> Instagram
            </a>
            <a
              href={BRAND.tiktok}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white bg-black hover:bg-[color:var(--ink)] transition-transform hover:-translate-y-0.5"
            >
              <TikTokIcon className="w-4 h-4" /> TikTok
            </a>
            <a
              href={BRAND.facebook}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white bg-[#1877F2] hover:bg-[#1467d3] transition-transform hover:-translate-y-0.5"
            >
              <FacebookIcon className="w-4 h-4" /> Facebook
            </a>
          </div>
        </div>

        {/* Behold widget — auto-updates posts from @trustme_laundry. Fully responsive on all devices. */}
        <div className="behold-wrapper w-full">
          <div data-behold-id={BEHOLD_ID} className="w-full" />
        </div>

        <div className="mt-8 text-center">
          <a
            href={BRAND.instagram}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--brand)] hover:text-[color:var(--brand-600)]"
          >
            Lihat semua postingan di Instagram <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
